import { ComponentStoreV2Factory } from '../../../../modules/shared/store/common/component-store-v2.factory';
import { computed, effect, Injectable, signal } from '@angular/core';
import { WorkGridItemObject, WorkOfferObject } from '@it2go/types';

import { ProtocolItem, ProtocolItemOffer } from './folder-protocols-widget.types';
import { mapWorkOfferToTableOffer } from '../../work/work.utils';

type WorkOfferWithProtocol = WorkOfferObject & {
    protocol?: string | null;
};

@Injectable()
export class FolderProtocolsWidgetStore extends ComponentStoreV2Factory {
    public worksData = computed(() => {
        const ret = this.data.getWorks();

        let items: any[] = [];

        (ret?.['items'] || []).forEach((it: WorkGridItemObject) => {
            items.push(<ProtocolItem>{
                id: it.id,
                serviceId: it.serviceId,
                dateFrom: it.dateFrom,
                dateTo: it.dateTo,
                workType: it.workType,
                protocol: (it.workData as any)?.protocol,
                users: it.users,
                tags: it.tags,
                offers: it.offers,
                filledOffersProtocols: this.mapFilledOffersProtocols(it.offers),
                __hideDelete: it.isBilled,
            });
        });

        return {
            ...ret,
            items,
        };
    });

    public expandedKeys = signal<{ [p: string]: boolean }>({});

    constructor() {
        super();

        effect(() => {
            this.expandedKeys.set(Object.fromEntries(this.worksData().items.map((p) => [p.id, true])));
        });
    }

    private mapFilledOffersProtocols(offers: WorkOfferObject[]): ProtocolItemOffer[] {
        return offers.reduce<ProtocolItemOffer[]>((acc, offer) => {
            const offerWithProtocol = offer as WorkOfferWithProtocol;
            if (offerWithProtocol.protocol === '') {
                return acc;
            }

            acc.push({
                ...mapWorkOfferToTableOffer(offer),
                protocol: offerWithProtocol.protocol ?? null,
                tags: offer.tags,
            } as ProtocolItemOffer);

            return acc;
        }, []);
    }
}
